import { ExitGuideButton, PreviousStepButton } from '../../components';
import nls from '../../../../nls/pt-BR.json';
import { useDispatch } from 'react-redux';
import {
  removeClusters,
  removeMarkers,
  setDisplayCharts,
  setIsLoadingMap,
} from '../../../../../redux/dashboardActions';
import { postStudyStep } from '../../../../redux/studies.controller';
import { useTypedSelector } from '../../../../../../../hooks/useTypedSelector';
import {
  advanceToStep,
  setAbsorptionLiquidityResponsePrimary,
  setAbsorptionLiquidityResponseSecondary,
  setAuthor,
  setExpandedAreaPolygon,
  studiesSelector,
} from '../../../../redux/studies.reducer';
import { useEffect } from 'react';

export const AbsorptionAndLiquidity: React.FC = () => {
  const dispatch = useDispatch();
  const { id, currentStep } = useTypedSelector(studiesSelector);
  useEffect(() => {
    dispatch([setDisplayCharts(null), removeMarkers(), removeClusters()]);
  }, []);
  const handleClickCalculate = async () => {
    try {
      dispatch(setIsLoadingMap(true));
      const response = await postStudyStep(7, id, {});
      const {
        absorption_liquidity: { primary_market, secondary_market },
      } = response;

      if (response.expandedArea) {
        const { center, radius } = response.expandedArea;
        const newCircle = new google.maps.Circle({
          center: new google.maps.LatLng(center[0], center[1]),
          radius,
        });
        dispatch(setExpandedAreaPolygon(newCircle));
      }
      if (secondary_market)
        dispatch(setAbsorptionLiquidityResponseSecondary(secondary_market));
      dispatch(setAbsorptionLiquidityResponsePrimary(primary_market));
      dispatch(setAuthor(response.author));
      dispatch(advanceToStep(currentStep.nextStep));
    } catch (e) {
      console.error(e);
    } finally {
      dispatch(setIsLoadingMap(false));
    }
  };
  return (
    <>
      <p className="helper-text">{nls.studyCreationGuide.steps.step7.helper}</p>
      <div className="study-creation-guide__buttons-container">
        <div>
          <ExitGuideButton />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 8,
          }}
        >
          <PreviousStepButton />
          <button
            className="btn normal primary"
            data-cy="StudyCreationGuideNextStep"
            onClick={handleClickCalculate}
          >
            {nls.studyCreationGuide.buttons.calculate}
          </button>
        </div>
      </div>
    </>
  );
};
